import { type ReactNode } from "react";
import { Col, Row } from "../../../../common/components/Layout";
import { CheckoutSummaryItem } from "./CheckoutSummary";
import { useTranslation } from "react-i18next";

interface Props {
  email: string;
  name: string;
  lastName: string;
  plant: string;
  timeZone: string;
  language: string;
  country: string;
  children: ReactNode;
}

export const CheckoutOptimeSubscriptionSummary = ({
  email,
  name,
  lastName,
  plant,
  timeZone,
  language,
  country,
  children,
}: Props) => {
  const { t } = useTranslation();

  const headT = (suffix: string) => t(`page.checkout.optime.form.${suffix}`);

  return (
    <>
      <h2 className={"headline-small mb-0 mt-30"}>{t(`page.checkout.optime.header.summary`)}</h2>
      <Row>
        <Col size={4}>
          <CheckoutSummaryItem title={headT("email")}>
            <span>{email || "-"}</span>
          </CheckoutSummaryItem>
          <CheckoutSummaryItem title={headT("name")}>
            <span>{name || "-"}</span>
          </CheckoutSummaryItem>
          <CheckoutSummaryItem title={headT("lastName")}>
            <span>{lastName || "-"}</span>
          </CheckoutSummaryItem>
        </Col>
        <Col size={4}>
          <CheckoutSummaryItem title={headT("plant")}>
            <span>{plant || "-"}</span>
          </CheckoutSummaryItem>
          <CheckoutSummaryItem title={headT("timeZone")}>
            <span>{timeZone || "-"}</span>
          </CheckoutSummaryItem>
          <CheckoutSummaryItem title={headT("language")}>
            <span>{language || "-"}</span>
          </CheckoutSummaryItem>
          <CheckoutSummaryItem title={headT("country")}>
            <span>{country || "-"}</span>
          </CheckoutSummaryItem>
        </Col>
        <Col size={4} className={"d-flex flex-align-end"}>
          {children}
        </Col>
      </Row>
    </>
  );
};
